export default "__VITE_ASSET__CIv7LEtd__"